import React, { Activity, FC } from 'react';

const AnimatedRenderer: FC<
  React.PropsWithChildren<{
    isOpen: boolean;
  }>
> = ({ isOpen, children }) => {
  return <Activity mode={isOpen ? 'visible' : 'hidden'}>{children}</Activity>;
};

export default AnimatedRenderer;
